<template lang="html">
  <div>

    <section class="section" v-if="item !== null">
      <div class="box">

        <div class="container">
          <h1 class="title">{{ blogs[item].title }}</h1>
          <p class="subtitle">{{ blogs[item].date }}</p>
        </div>

        <div class="container">
          <div class="content" v-html="blogs[item].body">
          </div>
        </div>

        <!-- <div class="container">
          <div class="comments">
            <vue-disqus shortname="strange-software" :identifier="blogs[item].disqus"></vue-disqus>
          </div>
        </div> -->
      </div>
    </section>

    <section class="section" v-if="blogs && blogs.length">
      <div class="box" v-for="blog of blogs" :key="blog.id">

        <div class="container" v-if="item == null || blogs[item].path != blog.path">
          <router-link :to="/blog/ + blog.path"><h1 class="blog-title">{{ blog.title }}</h1></router-link>
          <p>{{ blog.date }}</p>
        </div>

        <div class="container" v-if="item != null && blogs[item].path == blog.path">
          <h1 class="blog-title-dark">{{ blog.title }}</h1>
        </div>

      </div>

    </section>

</div>
</template>

<script>
import VueDisqus from 'vue-disqus/VueDisqus.vue'

export default {
  components: {
    VueDisqus
  },
  name: 'blog',
  props: ['item'],
  data: () => ({
    blogs: [
      {
        'path': 'off-the-bus',
        'title': 'Off the Bus',
        'body': `<p>In light of all the AudioBus/IAA requests for <a href="/ipad/soup">Soup</a>, I thought I should share some background. The choice to eschew these options was far from arbitrary. I knew some users would still want AudioBus, but it didn't seem wise in terms of interaction, performance, and ease of development.

</p><p>I can't say I'm convinced the choice was the wrong one, but people have been clamoring for AudioBus, so here's the story. We're listening to your comments, and the story might change.

</p><p>Soup was conceived some years ago, originally running on the desktop using openFrameworks. It was the conceptual successor to Spunk, which was also a desktop app. I thought about porting it to iOS, did some tests, and the results were too dismal to move forward.

</p><p>Years passed, iPads got faster, some even got Pro. Every now and again the old Soup prototype would nag at me, begging for release. It was probably way too niche to make any business sense, but I really loved the concept and wanted to find a way to finish it up and share it with the world. It was originally going to be a desktop app, but the fluid aspect was really best served by touch. I finally got a port runnning on an iPad and scaled back the particle count until it could consistently produce audio without buffer underruns and utter glitch.

</p><p>With plugins now available on iOS, I naturally gave this option some thought. All of the touch interaction and the fact that the app was barely running given the hardware made standalone the obvious choice. It conceivably could be a plugin that you set-and-forget, but that takes away half of the experience. Moreover if someone fired up Soup with a few other synths and Garageband, all they would get is stuttering and digital distortion, an experience far from ideal.

</p><p>People have asked why MegaCurtisBig has AudioBus while Soup doesn't. Obviously we're reusing all of our code, right? Well, not quite all of it.

</p><p>We'd been using the low-level CoreAudio framework hitherto, but it seemed like now might finally be a good time to use something higher level to ease development and maintenance effort. I tried AudioKit for a little utility project (yet to be released) and really didn't enjoy the experience. It's an amazing framework to be sure, but it didn't serve our needs well.

</p><p>For Soup, I decided to try AVAudioEngine since Apple appeared to be invested in this as the way forward with iOS audio. This was also a little awkward, e.g. having to write an AudioUnit to generate sound, but it worked out in the end. The integration of AudioBus and AVAudioEngine looked even more awkward. Hopefuly someone will correct me here, but at the time of development there was no clear path forward without dipping back down to the RemoteIO CoreAudio level. It wasn't something to slap on quickly just in case.

</p><p>Overall it was looking like AudioBus wouldn't be that great of an experience and implementation would only take away from more Soupy features. Ergo no Bus.</p>
`,
        'date': '2018-05-03'
      }
    ],
    errors: []
  })
}
</script>



// WEBPACK FOOTER //
// src/components/Blog.vue